import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { RiyalIcon } from '@/lib/currency';

export default function SpendingWidget({ stats }) {
  const s = stats || {};
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <Card className="border-border">
        <CardHeader><CardTitle className="font-outfit text-base">Cash vs Bank Spending</CardTitle></CardHeader>
        <CardContent>
          <div className="space-y-3">
            <div className="flex justify-between items-center p-3 bg-cash/10 rounded-lg"><span className="text-sm">Expenses (Cash)</span><span className="font-bold text-cash inline-flex items-center gap-0.5"><RiyalIcon size="0.85em" /> {(s.expenses_cash || 0).toFixed(2)}</span></div>
            <div className="flex justify-between items-center p-3 bg-bank/10 rounded-lg"><span className="text-sm">Expenses (Bank)</span><span className="font-bold text-bank inline-flex items-center gap-0.5"><RiyalIcon size="0.85em" /> {(s.expenses_bank || 0).toFixed(2)}</span></div>
            <div className="flex justify-between items-center p-3 bg-cash/10 rounded-lg"><span className="text-sm">Supplier Pay (Cash)</span><span className="font-bold text-cash inline-flex items-center gap-0.5"><RiyalIcon size="0.85em" /> {(s.sp_cash || 0).toFixed(2)}</span></div>
            <div className="flex justify-between items-center p-3 bg-bank/10 rounded-lg"><span className="text-sm">Supplier Pay (Bank)</span><span className="font-bold text-bank inline-flex items-center gap-0.5"><RiyalIcon size="0.85em" /> {(s.sp_bank || 0).toFixed(2)}</span></div>
          </div>
        </CardContent>
      </Card>
      <Card className="border-border">
        <CardHeader><CardTitle className="font-outfit text-base">Expense Categories</CardTitle></CardHeader>
        <CardContent>
          <div className="space-y-2">
            {s.expense_by_category && Object.entries(s.expense_by_category).sort((a, b) => b[1] - a[1]).map(([cat, amt]) => (
              <div key={cat} className="flex justify-between items-center p-2 bg-secondary/50 rounded" data-testid="expense-cat-item">
                <span className="text-sm capitalize">{cat.replace('_', ' ')}</span>
                <span className="font-bold text-sm inline-flex items-center gap-0.5"><RiyalIcon size="0.85em" /> {amt.toFixed(2)}</span>
              </div>
            ))}
            {(!s.expense_by_category || Object.keys(s.expense_by_category).length === 0) && <p className="text-sm text-muted-foreground text-center py-4">No expenses</p>}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
